import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import XeroNetworkKeySettings from '../../components/HostPayments/Xero Network Key/XeroNetworkKeySettings';

const XeroNetworkKeyPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const theme = useTheme();
    const onClickGoBack = () => {
        navigate(-1);
    };

    return (
        <Grid
            sx={{
                width: '100%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <XeroNetworkKeySettings />
            <Grid sx={{ height: isMobile ? '5%' : '5%' }}>
                {' '}
                <CustomButton
                    onClick={onClickGoBack}
                    color='primary'
                    sx={{
                        marginLeft: !isMobile ? '-8px' : '-18px',
                        '&:hover': {
                            cursor: 'pointer',
                            color: theme.palette.textAccent.main,
                            backgroundColor: 'transparent',
                            background: 'none',
                        },
                    }}
                >
                    <ArrowBackIcon />{' '}
                    {isMobile ? null : (
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to Admin Centre
                        </Typography>
                    )}
                </CustomButton>
            </Grid>
        </Grid>
    );
};

export default XeroNetworkKeyPage;
